import { render, staticRenderFns } from "./RecommendationBundle.vue?vue&type=template&id=2eb60574&"
import script from "./RecommendationBundle.vue?vue&type=script&lang=js&"
export * from "./RecommendationBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports